module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_mens_make-9ebf6b660af399e775318f13697784c0.jpg";